export const buildContent = ( index, text = "", postType = null ) => {
	const content = document.createElement( "div" );

	if ( postType === null ) {
		content.classList.add( "map-marker" );

		content.innerHTML = `
			<div class="map-marker__icon">
					<svg width="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 70 120 200 120 200s120-130 120-200zm-160-8a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM373.9 265.1C366.4 275.3 359 285 352 293.9V452.2L224 405.7V293.9c-7-8.8-14.4-18.5-21.9-28.8c-8.8-12.1-17.8-25.1-26.1-38.6V405.3l-128 41V195l96.6-30.9c-5.2-14.6-8.6-29.6-8.6-44.1c0-1.2 0-2.4 0-3.5L0 160V461.6 512l48-15.4L200 448l176 64 200-64V146.4 96l-48 15.4-90 28.8c-3.6 19-11.5 38.1-20.3 55.2l-1.1 2L528 161.8V413l-128 41V226.5c-8.4 13.4-17.3 26.5-26.1 38.6z" fill="white" /></svg>
			</div>`;
	} else {
		content.classList.add( "route-marker" );

		content.innerHTML = `
			<div class="route-marker__icon">
					<span class="route-marker__number">${index}</span>
					<span class="route-marker__text">${text}</span>
			</div>`;
	}

	return content;
};
